<template>

    <cms-view>

        <cms-heading title="Reparaties" icon="entypo-tools"></cms-heading>

        <cms-heading title="Openstaand" level="2"></cms-heading>
        <cms-table-panel v-spinner="loadingPending" :placeholder="!pendingRepairs.items || !pendingRepairs.items.length" clickable="true">
            <tr>
                <cms-th field="reference" v-model="sortPending">Referentie</cms-th>
                <cms-th field="startDate" v-model="sortPending">Startdatum</cms-th>
                <cms-th field="endDate" v-model="sortPending">Verwachte einddatum</cms-th>
                <cms-th>Aantal loggers</cms-th>
                <cms-th></cms-th>
            </tr>
            <tr v-for="repair in pendingRepairs.items" @click="showRepair(repair)">
                <td>{{ repair.reference }}</td>
                <td>{{ repair.startDate | date('LL') }}</td>
                <td>{{ repair.endDate | date('LL') }}</td>
                <td>{{ repair.loggers.itemCount }}</td>
                <td class="actions" @click.stop>
                    <cms-link icon="magicon-edit" v-tooltip="'Wijzigen'" :to="{ name: 'repair-edit', params: { id: repair.id } }" v-if="userIsAdmin" />
                    <cms-link icon="entypo-eye" v-tooltip="'Reparatie bekijken'" :to="{ name: 'repair-view', params: { id: repair.id } }" />
                </td>
            </tr>
        </cms-table-panel>

        <cms-heading title="Archief" level="2"></cms-heading>
        <cms-table-panel v-spinner="resolvedPending" :item-count="resolvedRepairs.totalCount || 0" :items-per-page="itemsPerPage" @page="offset = arguments[0]" :placeholder="!resolvedRepairs.items || !resolvedRepairs.items.length" clickable="true">
            <cms-table-header>
                <cms-th field="reference" v-model="sortResolved">Referentie</cms-th>
                <cms-th field="startDate" v-model="sortResolved">Startdatum</cms-th>
                <cms-th field="endDate" v-model="sortResolved">Einddatum</cms-th>
                <cms-th>Aantal loggers</cms-th>
                <cms-th></cms-th>
            </cms-table-header>
            <tr v-for="repair in resolvedRepairs.items" @click="showRepair(repair)">
                <td>{{ repair.reference }}</td>
                <td>{{ repair.startDate | date('LL') }}</td>
                <td>{{ repair.endDate | date('LL') }}</td>
                <td>{{ repair.loggers.itemCount }}</td>
                <td class="actions" @click.stop>
                    <cms-link icon="magicon-edit" v-tooltip="'Wijzigen'" :to="{ name: 'repair-edit', params: { id: repair.id } }" v-if="userIsAdmin" />
                    <cms-link icon="entypo-eye" v-tooltip="'Reparatie bekijken'" :to="{ name: 'repair-view', params: { id: repair.id } }" />
                </td>
            </tr>
        </cms-table-panel>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag'

    import RepairState from 'app/enums/RepairState'
    import UserRole from 'app/enums/UserRole'

    import RepairQueries from 'app/queries/RepairQueries'

    @Component({

        name: 'repairs',
        apollo: {

            pendingRepairs: RepairQueries.all({

                loadingKey: 'loadingPending',
                fetchPolicy: 'cache-and-network',
                variables(){

                    return {

                        offset: null,
                        limit: null,
                        sortField: this.sortPending.field,
                        sortDirection: this.sortPending.direction,
                        filter: {
                            state: RepairState.PENDING
                        }
                    }
                }
            }),

            resolvedRepairs: RepairQueries.all({

                loadingKey: 'resolvedPending',
                fetchPolicy: 'cache-and-network',
                variables(){

                    return {

                        offset: this.offset,
                        limit: this.itemsPerPage,
                        sortField: this.sortResolved.field,
                        sortDirection: this.sortResolved.direction,
                        filter: {
                            state: RepairState.RESOLVED
                        }
                    }
                }
            }),
        }
    })
    export default class Repairs extends Vue
    {
        static PENDING_SORT_STORAGE_KEY = "RepairsPendingSort";
        static RESOLVED_SORT_STORAGE_KEY = "RepairsResolvedSort";

        data(){

            return {

                pendingRepairs: {},
                resolvedRepairs: {},
                loadingPending: 0,
                resolvedPending: 0,

                offset: 0,
                itemsPerPage: 20,
                sortPending: this.$storage.getSession(Repairs.PENDING_SORT_STORAGE_KEY, {
                    field: 'startDate',
                    direction: 'ASC'
                }),
                sortResolved: this.$storage.getSession(Repairs.RESOLVED_SORT_STORAGE_KEY, {
                    field: 'startDate',
                    direction: 'DESC'
                })
            }
        }

        breadcrumb(){

            return 'Reparaties';
        }

        created(){

            this.logger = this.$logger.child('Repairs');

            this.$watch('sortPending', (sort) => this.$storage.setSession(Repairs.PENDING_SORT_STORAGE_KEY, sort));
            this.$watch('sortResolved', (sort) => this.$storage.setSession(Repairs.RESOLVED_SORT_STORAGE_KEY, sort));
        }

        showRepair(repair){

            this.$router.push({
                name: 'repair-view',
                params: { id: repair.id }
            });
        }

        get userIsAdmin(){

            return [UserRole.ADMIN].indexOf(this.$user.role) >= 0;
        }
    }

</script>